import { SET_LOCALE } from './constants';

export function setLocale(payload) {
  return {
    type: SET_LOCALE,
    payload,
  };
}
